export const slimeDeath = new Image();
slimeDeath.src = "./assets/characterSprites/slime/SlimeSheet.png";
slimeDeath.width = 256 / 8
slimeDeath.height = 75 / 3
slimeDeath.yOffset = 117.5
slimeDeath.xOffset = 195
slimeDeath.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];